import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/ranakpur.jpg";
import Newsletter from "../../shared/Newsletter";

const Ranakpur = () => {
  return (
    <>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          Ranakpur
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Desuri</li>
                      <li>Sadri</li>
                      <li>Muchhala Mahaveer:</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Ranakpur
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Located 96 kms from Udaipur, it is the site of one of the
                    most important Jain Temples in India. The Marvelous temples
                    over here are living testimony to the wonders that abiding
                    faith and unreleting pursuit of excellence can create.
                  </p>
                  <p>
                    The temple is constructed on an extensive platform and the
                    whole edifice is made up of domes and towers, courtyards and
                    cells, each with a pyramidal roof. These 500 year old
                    temples have been preserved in Adinath, is a 3 storeyed
                    structure, with 29 halls, 80 domes and 1,444 pillars and no
                    two pillars are alike. Every pillar is intricately carved,
                    infact every conceivable surface is carved with equal
                    delicacy.
                  </p>

                  <p>
                    There are four subsidiary shrines with 80 spires supported
                    by 420 columns. The entire temple is encircled with corridor
                    having Tirthankara images. A small shrine of Lord Parsvanth
                    in front of the main temple, has a black image of the
                    tirthankara in the inner sanctum.
                  </p>

                  <p>
                    Through the great vision and scholarly skills of Maharaja
                    Sawai Jai Singh II and extensive works by his Chief
                    Architect Vidyadhar Bhattacharji, Jaipur rose to fame as the
                    most beautiful and the best planned place to live in.
                    Liberal, protective and secular policies of the rulers
                    attracted a wide range of artisans, artists and businessmen,
                    which today make this city, a great arts, crafts, trade and
                    cultural centre. Architecturally, the city proved to be a
                    milestone and other great kings like Sawai Ram Singh and
                    Sawai Mansingh II added many more public buildings and
                    institutions to this existing masterpiece.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Desuri
                  </h2>

                  <p>
                    Desuri is part of erstwhile Godwad. There are three Jain
                    temples, and temple of Shiva and Hanuman. The temple of
                    Parsuram Mahadeo amidst the hills is worth seeing.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Sadri
                  </h2>
                  <p>
                    Sadri is famous for the beautiful temples of Barahavtar and
                    Chintamani Parasnath. It also has an old dargah, of
                    Khudabakhsh Baba.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Muchhala Mahaveer
                  </h2>
                  <p>
                    5 kms from Ghanerao, in the Kumbhalgarh sanctuary, the Jain
                    temple is a contemporary of the Ranakpur temple. It is the
                    only temple where Lord Mahaveer is depicted with moustache.
                    There are many local legends about it.
                  </p>

                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Ranakpur;
